import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import { CartProvider } from "./context/CartContext";
import { LocationProvider } from "./context/LocationContext";
import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
import ShopPage from "./pages/ShopPage";
import ProductDetailsPageOne from "./pages/ProductDetailsPageOne";
import ProductDetailsPageTwo from "./pages/ProductDetailsPageTwo";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import AccountPage from "./pages/AccountPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import TrackOrderPage from "./pages/TrackOrderPage";
import TestDesignPage from "./pages/TestDesignPage";
import ContactPage from "./pages/ContactPage";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import VendorPage from "./pages/VendorPage";
import VendorDetailsPage from "./pages/VendorDetailsPage";
import VendorTwoPage from "./pages/VendorTwoPage";
import VendorTwoDetailsPage from "./pages/VendorTwoDetailsPage";
import BecomeSellerPage from "./pages/BecomeSellerPage";
import WishlistPage from "./pages/WishlistPage";
import MyOrdersPage from "./pages/MyOrdersPage";
import AccessGuard from "./components/AccessGuard";

// Admin Pages
import { AuthProvider } from "./admin/context/AuthContext";
import Login from "./admin/pages/Login";
import Register from "./admin/pages/Register";
import ProtectedRoute from "./admin/components/ProtectedRoute";
import Dashboard from "./admin/pages/Dashboard";
import DashboardLayout from "./admin/components/DashboardLayout";
import ProductIndex from "./admin/pages/products/ProductIndex";
import ProductCreate from "./admin/pages/products/ProductCreate";
import ProductEdit from "./admin/pages/products/ProductEdit";
import CategoryIndex from "./admin/pages/categories/CategoryIndex";
import CategoryCreate from "./admin/pages/categories/CategoryCreate";
import CategoryEdit from "./admin/pages/categories/CategoryEdit";
import FamilyIndex from "./admin/pages/families/FamilyIndex";
import FamilyCreate from "./admin/pages/families/FamilyCreate";
import FamilyEdit from "./admin/pages/families/FamilyEdit";
import WarehouseIndex from "./admin/pages/warehouses/WarehouseIndex";
import WarehouseCreate from "./admin/pages/warehouses/WarehouseCreate";
import WarehouseEdit from "./admin/pages/warehouses/WarehouseEdit";
import OfferIndex from "./admin/pages/offers/OfferIndex";
import OfferCreate from "./admin/pages/offers/OfferCreate";
import OfferEdit from "./admin/pages/offers/OfferEdit";
import OrderIndex from "./admin/pages/orders/OrderIndex";
import OrderCreate from "./admin/pages/orders/OrderCreate";
import OrderEdit from "./admin/pages/orders/OrderEdit";
import OrderShow from "./admin/pages/orders/OrderShow";
import CustomerCreate from "./admin/pages/customer/CustomerCreate";
import CustomerIndex from "./admin/pages/customer/CustomerIndex";
import CustomerEdit from "./admin/pages/customer/CustomerEdit";
import FinanceReport from "./admin/pages/reports/FinanceReport";
import StockReport from "./admin/pages/reports/StockReport";
import SecurityReport from "./admin/pages/reports/SecurityReport";
import SupplierIndex from "./admin/pages/suppliers/SupplierIndex";
import SupplierCreate from "./admin/pages/suppliers/SupplierCreate";
import SupplierEdit from "./admin/pages/suppliers/SupplierEdit";
import PackIndex from "./admin/pages/packs/PackIndex";
import PackCreate from "./admin/pages/packs/PackCreate";
import PackEdit from "./admin/pages/packs/PackEdit";
import PackShow from "./admin/pages/packs/PackShow";
import Settings from "./admin/pages/settings/Settings";
import NotificationsPage from "./admin/pages/notifications/NotificationsPage";
import Profile from "./admin/pages/Profile";
import ContactMessages from "./admin/pages/contacts/ContactMessages";

function App() {
  return (
    <BrowserRouter>
      <LocationProvider>
        <CartProvider>
          <RouteScrollToTop />
          <PhosphorIconInit />

        <AccessGuard>
        <Routes>
        {/* Landing Page Routes */}
        <Route exact path='/' element={<HomePageOne />} />
        <Route exact path='/index-two' element={<HomePageTwo />} />
        <Route exact path='/index-three' element={<HomePageThree />} />
        <Route exact path='/shop' element={<ShopPage />} />
        <Route
          exact
          path='/product-details/:id'
          element={<ProductDetailsPageOne />}
        />
        <Route
          exact
          path='/product-details'
          element={<ProductDetailsPageOne />}
        />
        <Route
          exact
          path='/product-details-two'
          element={<ProductDetailsPageTwo />}
        />
        <Route exact path='/cart' element={<CartPage />} />
        <Route exact path='/checkout' element={
          <AuthProvider>
            <CheckoutPage />
          </AuthProvider>
        } />
        <Route exact path='/become-seller' element={<BecomeSellerPage />} />
        <Route exact path='/wishlist' element={<WishlistPage />} />
        <Route exact path='/account' element={<AccountPage />} />
        <Route exact path='/my-orders' element={<MyOrdersPage />} />
        <Route exact path='/blog' element={<BlogPage />} />
        <Route exact path='/blog-details' element={<BlogDetailsPage />} />
        <Route exact path='/track-order' element={<TrackOrderPage />} />
        <Route exact path='/test-design' element={<TestDesignPage />} />
        <Route exact path='/contact' element={<ContactPage />} />
        <Route exact path='/vendor' element={<VendorPage />} />
        <Route exact path='/vendor-details' element={<VendorDetailsPage />} />
        <Route exact path='/vendor-two' element={<VendorTwoPage />} />
        <Route
          exact
          path='/vendor-two-details'
          element={<VendorTwoDetailsPage />}
        />

        {/* Admin Routes */}
        <Route path='/admin/login' element={
          <AuthProvider>
            <Login />
          </AuthProvider>
        } />
        <Route path='/admin/register' element={
          <AuthProvider>
            <Register />
          </AuthProvider>
        } />
        <Route path='/admin' element={
          <AuthProvider>
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          </AuthProvider>
        }>
          <Route index element={<Dashboard />} />
          <Route path='dashboard' element={<Dashboard />} />
          <Route path='products/product-list' element={<ProductIndex />} />
          <Route path='products/product-add' element={<ProductCreate />} />
          <Route path='products/product-edit/:id' element={<ProductEdit />} />
          <Route path='families/family-list' element={<FamilyIndex />} />
          <Route path='families/family-add' element={<FamilyCreate />} />
          <Route path='families/family-edit/:id' element={<FamilyEdit />} />
          <Route path='categories/category-list' element={<CategoryIndex />} />
          <Route path='categories/category-add' element={<CategoryCreate />} />
          <Route path='categories/category-edit/:id' element={<CategoryEdit />} />
          <Route path='warehouses/warehouse-list' element={<WarehouseIndex />} />
          <Route path='warehouses/warehouse-add' element={<WarehouseCreate />} />
          <Route path='warehouses/warehouse-edit/:id' element={<WarehouseEdit />} />
          <Route path='offers/offer-list' element={<OfferIndex />} />
          <Route path='offers/offer-add' element={<OfferCreate />} />
          <Route path='offers/offer-edit/:id' element={<OfferEdit />} />
          <Route path='orders/orders-list' element={<OrderIndex />} />
          <Route path='orders/order-add' element={<OrderCreate />} />
          <Route path='orders/order-show/:id' element={<OrderShow />} />
          <Route path='orders/order-edit/:id' element={<OrderEdit />} />
          <Route path='customer/customer-create' element={<CustomerCreate />} />
          <Route path='customer/customer-list' element={<CustomerIndex />} />
          <Route path='customer/customer-edit/:id' element={<CustomerEdit />} />
          <Route path='suppliers/supplier-list' element={<SupplierIndex />} />
          <Route path='suppliers/supplier-add' element={<SupplierCreate />} />
          <Route path='suppliers/supplier-edit/:id' element={<SupplierEdit />} />
          <Route path='packs/pack-list' element={<PackIndex />} />
          <Route path='packs/pack-add' element={<PackCreate />} />
          <Route path='packs/pack-edit/:id' element={<PackEdit />} />
          <Route path='packs/pack-show/:id' element={<PackShow />} />
          <Route path='reports/finance' element={<FinanceReport />} />
          <Route path='reports/stock' element={<StockReport />} />
          <Route path='reports/security' element={<SecurityReport />} />
          <Route path='notifications' element={<NotificationsPage />} />
          <Route path='contacts' element={<ContactMessages />} />
          <Route path='settings' element={<Settings />} />
          <Route path='profile' element={<Profile />} />
          <Route path='*' element={<Dashboard />} />
        </Route>
      </Routes>
        </AccessGuard>
        </CartProvider>
      </LocationProvider>
    </BrowserRouter>
  );
}

export default App;
